import mobileLoacation from "../asserts/delivery-van.svg"
import shopLoacation from "../asserts/car-wash.svg"

const Checked = (
  <svg
    className="size-5 text-green-600"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="m4.5 12.75 6 6 9-13.5"
    />
  </svg>
)

const Cross = (
  <svg
    className="size-5 text-red-600"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18 18 6M6 6l12 12"
    />
  </svg>
)

export const AppointmentData = [
  {
    // shop
    id: 0,
    displayName: "Appointment Shop",
    locationRole: "SHOP",
    imgUrl: shopLoacation,
    description: "5680 Dorset St Burnaby",
    ribbon: "",
    // ribbon: "20% off",
    locationDiscount: 20,
    bookingSlots: [
      {
        id: 0,
        time: "11:00am-12:00pm",
        availableSlots: 3,
      },
      {
        id: 1,
        time: "12:00pm-01:00pm",
        availableSlots: 3,
      },
      {
        id: 2,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
      {
        id: 3,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
      {
        id: 4,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
    ],
    staff: [
      //Car/Sedan
      {
        id: 0,
        staffDisplayName: "Car/Sedan",
        type: "car",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277375/car_sedan-removebg-preview_p9vpjb.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "10% off",
            tag: [],
            isAvailable: true,
            description: "",
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 850.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 650.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "10% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 500.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 600.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - Car Interior/Exterior",
                price: 320,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 15m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - Car Interior/Exterior",
                price: 240,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "3h",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - Car Interior/Exterior",
                price: 170,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "2h 15m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - Car Interior/Exterior",
                price: 150.0,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 50m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 70.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg", // Assuming this is what you meant by +$ 140.00 CAD
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 120.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 20m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 230.0,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior Car With Clay Bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 110.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //SUV-5 Seats
      {
        id: 1,
        staffDisplayName: "SUV-5 Seats",
        type: "suv5",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277699/suv_5_seater_white-removebg-preview_ilib0i.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1250.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 950.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 800.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "10% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 650.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 750.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - SUV-5 Seats Interior/Exterior",
                price: 380,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - SUV-5 Interior/Exterior",
                price: 280,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - SUV-5 Interior/Exterior",
                price: 200,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "2h 55m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - SUV-5 Interior/Exterior",
                price: 160.0,
                salePrice: 0,
                tag: [],
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 10m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "20% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 15m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 130.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 130.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 270.0,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 25m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "20% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 15m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 130.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //Pickup Truck
      {
        id: 2,
        staffDisplayName: "Pickup Truck",
        type: "pickupTruck",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277817/Puckup_Truck-removebg-preview_vlwsyj.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "10% off",
            tag: [],
            description: "coating",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1500.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 1150.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "10% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 800.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 900.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - Pickup Interior/Exterior",
                price: 420,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "4h",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - Pickup Interior/Exterior",
                price: 290,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - Pickup Interior/Exterior",
                price: 200,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "2h 55m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - Pickup Interior/Exterior",
                price: 170.0,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "2h 20m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 90.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "20% off",
            description: "",
            tag: [],
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                tag: [],
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 15m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 160.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "1h 30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 270.0,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 25m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 200.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "1h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 150.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "50m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 85.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //SUV-7 Seats
      {
        id: 3,
        staffDisplayName: "SUV-7 Seats",
        type: "suv7",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277862/suv_7_seater-removebg-preview_moe1tc.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "10% off",
            tag: [],
            description: "coating",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1500.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 1150.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 800.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 900.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                discount: 10,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - SUV-7 Seats Interior/Exterior",
                price: 420,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "4h",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - SUV-7 Seats Interior/Exterior",
                price: 310,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - SUV-7 Seats Interior/Exterior",
                price: 220,
                salePrice: 0,
                ribbon: "20% off",
                tag: [],
                imageUrl: "",
                duration: "3h 20m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - Suv 7 Interior/Exterior",
                price: 170.0,
                salePrice: 0,
                tag: [],
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 35m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 90.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg", // Assuming this is what you meant by +$ 140.00 CAD
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 180.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "2h 30m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash + Tyres & Rims Shine",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 320.0,
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 25m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "20% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 200.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "1h 45m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 150.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "20% off",
                imageUrl: "",
                duration: "50m",
                discount: 20,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 85.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //Commercial Vehicles
      {
        id: 4,
        staffDisplayName: "Commercial",
        type: "commercialVehicle",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277924/Commercial_Truck-removebg-preview_ulo3fz.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Semi - Sleeper",
            type: "semiSleeper",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/semi-sleeper-e1724914832780.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: false,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, Refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 280.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, Refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 200.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 110.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Semi - Day Van",
            type: "semiDayCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Semi-Day-Cab.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: false,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 230.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 150.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Dump Truck Van",
            type: "dumpTruckCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Dump-Truck-Cab-.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: false,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 400.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 250.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Sprinter Van",
            type: "sprinterVanCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Sprinter-Van-Cab-2.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 225.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 135.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Commercial Van",
            type: "commercialVanCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Commercial-Van-Cab.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 225.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 135.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 5,
            categoryDisplayName: "Big Machines/Equipment",
            type: "bigMachines",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/BIG-MACHINE-EQUIPMENT.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: false,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Exterior High Pressure Wash using PH Balanced Soaps
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Spot Paint Decontamination</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Remove Grease, Oil, heavy dirt etc.</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 480.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Exterior High Pressure Wash using PH Balanced Soaps
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Spot Paint Decontamination</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Remove Grease, Oil, heavy dirt etc.</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 320.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      // Rv Motors
      {
        id: 5,
        staffDisplayName: "RVs Motorhomes",
        type: "rv",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277995/RV_motorhomes-removebg-preview_y7xulx.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "RV Services",
            type: "rvServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Wash, Wax, Buff and Polish",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "Wash, Wax, Buff and Polish",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 2,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 3,
                serviceDisplayName: "Interior Steam Detail",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "Interior Steam Detail",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Fire Truck
      {
        id: 6,
        staffDisplayName: "Fire Truck",
        type: "fireTruck",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278070/White_Fire_Truck-removebg-preview_hausrv.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Fire Truck Service",
            type: "truckServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Fire Truck",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "Fire Truck Work",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Passenger Bus
      {
        id: 7,
        staffDisplayName: "Passenger Bus",
        type: "passengerBus",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278127/bus-removebg-preview-1_woaqq8.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Bus Services",
            type: "busServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName:
                  "Full Interior with steam includes shampo carpet and seats",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Light interior with steam",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 15.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior wash , wax , Buff, polish",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 3,
                serviceDisplayName: "Exterior wash",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 10.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Boats
      {
        id: 8,
        staffDisplayName: "Boats",
        type: "boat",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278179/Yacht-removebg-preview_jbjuml.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Boats Services",
            type: "boatServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior Hull Wash",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 8.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Exterior Hull Wash, Wax, Buff, Polish",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 2,
                serviceDisplayName: "Exteriors - Remove Oxidation and Swirls",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 3,
                serviceDisplayName:
                  "Interior - Wash Steam & Clean Vinyl Surfaces (No carpets / Fabrics)",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 12.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Helicopter
      {
        id: 9,
        staffDisplayName: "Helicopter",
        type: "helicopter",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278231/White_Helicopter1-removebg_u3ffwu.webP",
        descritpion: "",
        tag: [],
        staffDiscount: 0,
        servicesList: [],
      },

      // House
      {
        id: 10,
        staffDisplayName: "House",
        type: "house",
        isAvailable: false,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278286/White_Small_House-removebg-preview_atpbam.webP",
        descritpion: "",
        tag: [],
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "House Wash Booking?",
            type: "houseServices",
            servCategoryImgUrl: "",
            ribbon: "",
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "House Wash",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "House Wash",
                price: 0.5,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    // mobile
    id: 1,
    displayName: "Appointment Mobile",
    locationRole: "MOBILE",
    imgUrl: mobileLoacation,
    description: "At Client Side",
    ribbon: "",
    // ribbon: "10% off",
    locationDiscount: 10,
    bookingSlots: [
      {
        id: 0,
        time: "11:00am-12:00pm",
        availableSlots: 3,
      },
      {
        id: 1,
        time: "12:00pm-01:00pm",
        availableSlots: 3,
      },
      {
        id: 2,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
      {
        id: 3,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
      {
        id: 4,
        time: "01:00pm-02:00pm",
        availableSlots: 3,
      },
    ],
    staff: [
      //Car/Sedan
      {
        id: 0,
        staffDisplayName: "Car/Sedan",
        type: "car",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277375/car_sedan-removebg-preview_p9vpjb.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: (
                      <>
                        Preparation <br />
                        Wheel Detailing
                        <br />
                        Iron & Tar Removal
                        <br />
                        Clay Bar
                        <br />
                        Treatment <br />
                        Correction 4 to 6 Hours spent on enhancing the paintwork{" "}
                        <br />
                        Removes Medium to Heavy Scratches and Swirl Marks,
                        Oxidation <br />
                        Final Touch Rewash to remove any dust or compound A
                        light Coat of Wax Maintenance Interior Detail
                      </>
                    ),
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 750.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 600.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 400.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 500.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 600.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - Car Interior/Exterior",
                price: 320,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "3h 15m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - Car Interior/Exterior",
                price: 240,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                duration: "3h",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - Car Interior/Exterior",
                price: 170,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 15m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - Car Interior/Exterior",
                price: 150,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                duration: "1h 50m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 70.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg", // Assuming this is what you meant by +$ 140.00 CAD
                    serviceDiscription: <></>,
                    duration: "30min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 45m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 120.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 20m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 230.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 25m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 15m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/5-1-e1622250307488.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 110.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "30min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "30min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //SUV-5 Seats
      {
        id: 1,
        staffDisplayName: "SUV-5 Seats",
        type: "suv5",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277699/suv_5_seater_white-removebg-preview_ilib0i.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1250.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 950.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 800.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 225.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 650.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 750.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - SUV-5 Seats Interior/Exterior",
                price: 380,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "3h 45m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - SUV-5 Interior/Exterior",
                price: 280,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "3h 30m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - SUV-5 Interior/Exterior",
                price: 200,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 55m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - SUV-5 Interior/Exterior",
                price: 160.0,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 10m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "2h 15m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 130.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 130.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 270.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 25m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 130.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "40m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //Pickup Truck
      {
        id: 2,
        staffDisplayName: "Pickup Truck",
        type: "pickupTruck",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277817/Puckup_Truck-removebg-preview_vlwsyj.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1500.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 1150.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 800.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 900.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - Pickup Interior/Exterior",
                price: 420,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "4h",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - Pickup Interior/Exterior",
                price: 290,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 45m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - Pickup Interior/Exterior",
                price: 200,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 55m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - Pickup Interior/Exterior",
                price: 170.0,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "2h 20m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 90.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "2h 15m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 160.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 140.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 270.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 25m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 200.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 45m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 150.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "50m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 85.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //SUV-7 Seats
      {
        id: 3,
        staffDisplayName: "SUV-7 Seats",
        type: "suv7",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277862/suv_7_seater-removebg-preview_moe1tc.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Ceramic Coating",
            type: "ceramicCoating",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/01/testimonial-detailing.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Diamond",
                serviceDiscription: (
                  <>
                    <h1>Diamond (Lifetime Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Engine Bay Detail</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>4 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Diamond (Lifetime Warranty)",
                price: 1500.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Gold",
                serviceDiscription: (
                  <>
                    <h1>Gold (5 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Pro 9H on the Paint</li>
                      <li>
                        1 Coat of Ceramic Pro Top Coat on the Paint - Glass
                        Coating
                      </li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Gold (5 Years Warranty)",
                price: 1150.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Silver",
                serviceDiscription: (
                  <>
                    <h1>Silver (2 Years Warranty)</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                      <li>Minimum Level 2 Paint Correction</li>
                    </ul>
                    <strong>COATING</strong>
                    <ul>
                      <li>2 Coats of Ceramic Coating on the Paint</li>
                      <li>Glass Coating</li>
                    </ul>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Final Inspection</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This includes Level 2 Paint
                      Correction if you have Medium to Heavy Scratches and Swirl
                      Marks, Oxidation. Please select Level 3 Paint Corrections
                      in Optional Service.
                    </p>
                  </>
                ),
                serviceShortDiscription: "Silver (2Years Warranty)",
                price: 1000.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Level 3 Paint Correction",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/two-stage-paint-correction-on-half-of-a-hood.jpg",
                    serviceShortDiscription: "",
                    price: 300.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wheel Coating",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/08/car-detailing-2.jpg",
                    serviceShortDiscription: "",
                    price: 500.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Interior Coating",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/interior-car-detailing.png",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 600.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Paint Correction",
            type: "paintCorrection",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/paint-11-scaled.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Level 2",
                serviceDiscription: (
                  <>
                    <h1>Level 2 Paint Correction</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 2 to 3 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Light to Medium Scratches
                      and Swirl Marks
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 2 PAINT CORRECTION PREPARATION",
                price: 800.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Level 3",
                serviceDiscription: (
                  <>
                    <h1>LEVEL 3 PAINT CORRECTION</h1>
                    <strong>PREPARATION</strong>
                    <ul>
                      <li>Wheel Detailing</li>
                      <li>Iron and Tar Removal</li>
                      <li>Clay Bar Treatment</li>
                    </ul>
                    <strong>CORRECTION</strong>
                    <p>
                      <strong>Duration:</strong> 4 to 6 Hours spent on enhancing
                      the paintwork
                    </p>
                    <p>
                      <strong>Action:</strong> Removes Medium to Heavy Scratches
                      and Swirl Marks, Oxidation
                    </p>
                    <strong>FINAL TOUCH</strong>
                    <ul>
                      <li>Rewash to remove any dust or compound</li>
                      <li>Light coat of Wax</li>
                      <li>Maintenance Interior Detail</li>
                    </ul>
                    <p>
                      <strong>Note:</strong> This process will not remove deep
                      Scratches that are beyond the clear coat.
                    </p>
                  </>
                ),
                serviceShortDiscription: "LEVEL 3 PAINT CORRECTION PREPARATION",
                price: 900.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Interior & Exterior Detailing",
            type: "interiorAndExteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/06/Car-Detailing-in-Maple-Ridge-2.jpg",
            ribbon: "10% off",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "A to Z Auto Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "A to Z Auto Detailing - SUV-7 Seats Interior/Exterior",
                price: 420,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "4h",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Full Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Exterior and Interior - SUV-7 Seats Interior/Exterior",
                price: 310,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                duration: "3h 45m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior & Light Exterior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Light Exterior - SUV-7 Seats Interior/Exterior",
                price: 220,
                salePrice: 0,
                ribbon: "10% off",
                tag: [],
                imageUrl: "",
                duration: "3h 20m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Interior With Steam & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Express Add on - SUV-7 Interior/Exterior",
                price: 170.0,
                salePrice: 0,
                ribbon: "10% off",
                imageUrl: "",
                duration: "2h 35m",
                discount: 10,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Polish",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/12/car-detailing-5.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 90.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg", // Assuming this is what you meant by +$ 140.00 CAD
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Interior Detailing",
            type: "interiorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2023/09/Auto-Detailing.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 180.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "2h 30m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash + Tyres & Rims Shine",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Interior Detailing with Steam (No Shampoo)",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div
                        style={{
                          color: "red",
                        }}
                      >
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Interior Detailing with Steam (No Shampoo)",
                price: 160.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 45m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 150.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 65.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 45.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 10,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Interior Detailing with Mold",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Interior Detailing with Mold",
                price: 320.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 50m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Exterior Wash +Tyres & Rims Shine",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/05/detailing-21.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Wash Wax, Buff + Tyres & Rims",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2023/04/BUFFING-scaled-1.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 110.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 30.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 8,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 9,
                    serviceDisplayName: "Kid Seat",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Exterior Detailing",
            type: "exteriorDetaling",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/02/car-detailing-services-in-Coquitlam.jpg",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Exterior car with clay bar",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR WITH CLAY BAR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Exterior: Hand Wash, Clay Bar and Machine Wax Polish, Wheel Clean & Tire Shine.",
                price: 200.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "1h 45m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 25.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 20.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Tar removal - ClayBar",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746250692/uploads/image_dbfa73576f95.webP",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Basic Package",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            color: "red",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Remove Tar, Tree Sap, Bug Splatter etc.
                          </strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Machine Wax Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Window & Windshield Clean From Outside
                          </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                      }}
                    >
                      <strong>Please Note:</strong> This is Hand Wash, Wax Buff
                      With Machine and Tire/Rim Clean Shine (Not Cut and
                      Polish).
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Basic Package: Hand Wash, Rim and Wheel Cleaning, Wax Buff, Tire Dressing, Door Jambs clean, Window and Windshield Clean.",
                price: 150.0, // Set the price accordingly
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                duration: "50m",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Interior Vacuum & Wipe Down",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2022/03/When-should-you-detail-your-car-boost-mobile-detailing.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Clay Bar",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/clay-bar.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 85.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min",
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      //fleet Vehicles
      // {
      //   id: 11,
      //   staffDisplayName: "Fleet Vehicle",
      //   type: "fleetVehicle",
      //   isAvailable: true,
      //   staffImgUrl:
      //     "https://res.cloudinary.com/djh8bzp9b/image/upload/v1746246592/uploads/image_08eca381ec38.webP",
      //   descritpion: "",
      //   ribbon: "25% OFF",
      //   staffDiscount: 0,
      //   servicesList: [],
      // },

      //Commercial Vehicles
      {
        id: 4,
        staffDisplayName: "Commercial",
        type: "commercialVehicle",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277924/Commercial_Truck-removebg-preview_ulo3fz.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Semi - Sleeper",
            type: "semiSleeper",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/semi-sleeper-e1724914832780.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, Refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 280.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Trunk/Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, Refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 200.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 110.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Semi - Day Van",
            type: "semiDayCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Semi-Day-Cab.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 230.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 150.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Dump Truck Van",
            type: "dumpTruckCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Dump-Truck-Cab-.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 400.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 250.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Sprinter Van",
            type: "sprinterVanCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Sprinter-Van-Cab-2.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 225.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 135.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Commercial Van",
            type: "commercialVanCab",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Commercial-Van-Cab.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 225.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 135.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Bay Wash & Polish</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 100.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 5,
            categoryDisplayName: "Big Machines/Equipment",
            type: "bigMachines",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/BIG-MACHINE-EQUIPMENT.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailng & Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Exterior High Pressure Wash using PH Balanced Soaps
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Spot Paint Decontamination</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Remove Grease, Oil, heavy dirt etc.</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailng & Exterior Wash",
                price: 480.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailng",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage area, Carpet, Floor Mats, Seats</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seat</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailng",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>
                            Exterior High Pressure Wash using PH Balanced Soaps
                          </strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Spot Paint Decontamination</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Remove Grease, Oil, heavy dirt etc.</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Engine Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            color: "red",
                            paddingTop: "1rem",
                          }}
                        >
                          <strong></strong>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 320.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      // Rv Motors
      {
        id: 5,
        staffDisplayName: "RVs Motorhomes",
        type: "rv",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719277995/RV_motorhomes-removebg-preview_y7xulx.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Class A Motorhome",
            type: "classA",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/RV-class-A-1.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior & Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Full Exterior",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Light Exterior",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                        color: "red",
                      }}
                    >
                      <strong>Offer Ceramic Coating:</strong> Add on $12 Per Ft,
                      (Resistant to Swirl Marks)
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 1,
            categoryDisplayName: "Class B (Campervans)",
            type: "classB",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/RV-class-B-1.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior & Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Full Exterior",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Light Exterior",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                        color: "red",
                      }}
                    >
                      <strong>Offer Ceramic Coating:</strong> Add on $12 Per Ft,
                      (Resistant to Swirl Marks)
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            categoryDisplayName: "Class C Motorhome",
            type: "classC",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/RV-class-C.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior & Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Full Exterior",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Light Exterior",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                        color: "red",
                      }}
                    >
                      <strong>Offer Ceramic Coating:</strong> Add on $12 Per Ft,
                      (Resistant to Swirl Marks)
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            categoryDisplayName: "Travel Trailer",
            type: "truckTrailer",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Travel-Trailer.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior & Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Full Exterior",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Light Exterior",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                        color: "red",
                      }}
                    >
                      <strong>Offer Ceramic Coating:</strong> Add on $12 Per Ft,
                      (Resistant to Swirl Marks)
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            categoryDisplayName: "Truck Camper",
            type: "truckCamper",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/08/Truck-Camper.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior & Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Full Exterior",
                price: 25.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior & Light Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior & Light Exterior",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName: "Full Interior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Entire Rv, Storage area, Carpet, Floor Mats, Seats
                            etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator.</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean Vents</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Pet Hair Removal</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior",
                price: 16.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Hand Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Roof Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Bug Removal</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wheel Clean & Tire Shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean vent cover</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Headlight</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks </strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{
                        marginTop: "1rem",
                        color: "red",
                      }}
                    >
                      <strong>Offer Ceramic Coating:</strong> Add on $12 Per Ft,
                      (Resistant to Swirl Marks)
                    </p>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 180.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 100.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Scotch Guard Protection",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/scotch.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 80.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 55.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 7,
                    serviceDisplayName: "Headlight Restoration",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/child-safety-seat-back-car-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      // Fire Truck
      {
        id: 6,
        staffDisplayName: "Fire Truck",
        type: "fireTruck",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278070/White_Fire_Truck-removebg-preview_hausrv.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Fire Truck Service",
            type: "truckServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Fire Truck",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "Fire Truck Work",
                price: 180.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Passenger Bus
      {
        id: 7,
        staffDisplayName: "Passenger Bus",
        type: "passengerBus",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278127/bus-removebg-preview-1_woaqq8.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "All Bus Services",
            type: "busServices",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/09/volvo-bus.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing and Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats, etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Tire/rim clean shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailing and Full Exterior",
                price: 18.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName:
                  "Steam Interior Detailing and Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats, etc.</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Tire/rim clean shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Steam Interior Detailing and Exterior Wash",
                price: 8.5,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 2,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Tire/rim clean shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 10.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 3,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Tire/rim clean shine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 3.5,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 4,
                serviceDisplayName: "Steam Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats, etc.</span>
                          <span>{Cross}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Steam Interior Detailing",
                price: 7.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
              {
                id: 5,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Carpet, Floor Mats, Seats, etc.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors.
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments.</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 9.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // Boats
      {
        id: 8,
        staffDisplayName: "Boats",
        type: "boat",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278179/Yacht-removebg-preview_jbjuml.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "All Boats Services",
            type: "boatServices",
            servCategoryImgUrl:
              "https://boostmobiledetailing.ca/wp-content/uploads/2024/09/vecteezy_yacht-yacht-transparent-background-yachting-luxurious-boat_27232222.png",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "Full Interior Detailing AND Full Exterior",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Storage area, Carpet, Floor Mats, Seats etc
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Hull Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Entire Boat Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wet Sanding</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailing AND Full Exterior",
                price: 26.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 1,
                serviceDisplayName: "Full Interior Detailing AND Exterior Wash",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Storage area, Carpet, Floor Mats, Seats etc
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Hull Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Entire Boat Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wet Sanding</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Full Interior Detailing AND Exterior Wash",
                price: 20.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 2,
                serviceDisplayName:
                  "Paint Correction (Oxidation & Swirl Marks)",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Hull Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Entire Boat Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wet Sanding</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription:
                  "Paint Correction (Oxidation & Swirl Marks)",
                price: 40.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 3,
                serviceDisplayName: "Full Exterior",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Hull Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Entire Boat Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wet Sanding</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Exterior",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 4,
                serviceDisplayName: "Exterior Wash",
                serviceDiscription: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "1rem",
                      }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>EXTERIOR</strong>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Exterior Hull Wash</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Entire Boat Wash & Wipe Down</strong>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wax/buff with machine</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Wet Sanding</strong>
                          <span>{Cross}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                            color: "red",
                          }}
                        >
                          <strong>Oxidation/Swirl Marks.</strong>
                          <span>{Cross}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Exterior Wash",
                price: 8.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
              {
                id: 5,
                serviceDisplayName: "Full Interior Detailing",
                serviceDiscription: (
                  <>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <strong>INTERIOR</strong>
                      </div>

                      <div>
                        <strong>Deep Vacuum:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Storage area, Carpet, Floor Mats, Seats etc
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Shampoo:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Carpet, Floor Mats, Seats, furniture sofa etc.
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Steam and Brush:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Entire kitchen and Bathroom</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • Dash and Center Console, Cup Holders, All Doors
                          </span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Storage compartments, refrigerator</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Roof</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Protection:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>
                            • All Hard Interior Surfaces, Leather Conditioning
                          </span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <strong>Windows and Windshield:</strong>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Inside</span>
                          <span>{Checked}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <span>• Outside</span>
                          <span>{Checked}</span>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed",
                            alignItems: "flex-end",
                          }}
                        >
                          <strong>Clean the bed/sleeping area</strong>
                          <span>{Checked}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                serviceShortDiscription: "Full Interior Detailing",
                price: 14.0,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [
                  {
                    id: 0,
                    serviceDisplayName: "Mold / Virus Removal + Ozone",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/photo_2024-07-04_12-09-09-2.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 120.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 1,
                    serviceDisplayName: "Pet Hair Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/889230769_max.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 60.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 2,
                    serviceDisplayName: "Cigg / Pot Smell",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/pexels-ron-lach-9530544c-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 3,
                    serviceDisplayName: "Odor Removal",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/04/Ozone-Generator.webp",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 40.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 4,
                    serviceDisplayName: "Engine Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2021/06/IMG_0637-scaled.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 5,
                    serviceDisplayName: "Undercarriage Wash",
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/614b7f84f0b9d9b5822d9769.jpg",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    serviceShortDiscription: "",
                    price: 35.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                  {
                    id: 6,
                    serviceDisplayName: "Headlight Restoration",
                    serviceDiscription: <></>,
                    duration: "40min", // Add description here if available
                    imageUrl:
                      "https://boostmobiledetailing.ca/wp-content/uploads/2024/07/IMG_7158-scaled.jpg",
                    serviceShortDiscription: "",
                    price: 50.0,
                    salePrice: 0,
                    ribbon: "",
                  },
                ],
              },
            ],
          },
        ],
      },

      // Helicopter
      {
        id: 9,
        staffDisplayName: "Helicopter",
        type: "helicopter",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278231/White_Helicopter1-removebg_u3ffwu.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "Type of Plane?",
            type: "planeServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "AirShip",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/Airship-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 1,
                serviceDisplayName: "Hot Air Balloon",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/hot_air_balloon-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 2,
                serviceDisplayName: "Glider",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/glider-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 3,
                serviceDisplayName: "Helicopter",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/helicopter-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 4,
                serviceDisplayName: "Gyroplane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/gyroplane-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 5,
                serviceDisplayName: "Tilrotor",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/Tiltrotor-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 6,
                serviceDisplayName: "MonoPlane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/MonoPlane-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 7,
                serviceDisplayName: "BiPlane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/Biplane-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 8,
                serviceDisplayName: "SeaPlane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/seaplane-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 9,
                serviceDisplayName: "Private Jet",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/PrivateJet-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 10,
                serviceDisplayName: "Passenger Plane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://res.cloudinary.com/dsprifizw/image/upload/v1719277567/Passenger-removebg-preview_lzdrwt.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 11,
                serviceDisplayName: "Cargo Plane",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/CargoPlane-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
              {
                id: 12,
                serviceDisplayName: "Military Jet",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "",
                price: 0,
                salePrice: 0,
                ribbon: "",
                imageUrl:
                  "https://boostmobiledetailing.ca/wp-content/uploads/2024/05/MilitaryJet-removebg-preview.png",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },

      // House
      {
        id: 10,
        staffDisplayName: "House",
        type: "house",
        isAvailable: true,
        staffImgUrl:
          "https://res.cloudinary.com/dsprifizw/image/upload/v1719278286/White_Small_House-removebg-preview_atpbam.webP",
        descritpion: "",
        staffDiscount: 0,
        servicesList: [
          {
            id: 0,
            categoryDisplayName: "House Wash Booking?",
            type: "houseServices",
            servCategoryImgUrl: "",
            ribbon: "",
            tag: [],
            description: "",
            isAvailable: true,
            services: [
              {
                id: 0,
                serviceDisplayName: "House Wash",
                serviceDiscription: <></>,
                duration: "40min",
                serviceShortDiscription: "House Wash",
                price: 0.5,
                salePrice: 0,
                ribbon: "",
                imageUrl: "",
                discount: 0,
                addonService: [],
              },
            ],
          },
        ],
      },
    ],
  },
]
